module.exports = __webpack_public_path__ + "res/Roboto-Bold-webfontd41d.eot?254d42b34a77bd40ef922522b5437c2f";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Bold-webfontd41d.eot
// module id = 22
// module chunks = 0